const translations = {
    connect: 'Connect',
    customerListSynced: 'Customer list last synced',
    customersSynced: 'customers synced',
    disconnect: 'Disconnect',
    quickBooksDescription:
        'This connection allows you to sync contacts and manage invoices directly with your QuickBooks® Online account.',
    quickBooksTitle: 'QuickBooks® Online',
    syncNow: 'Sync Now'
};

export default translations;
